import axios from 'axios';

const API_URL = 'https://opgametracker.com/api';
console.log('API_URL:', API_URL);

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

// Log the full baseURL
console.log('Full baseURL:', API_URL);

// Request interceptor
api.interceptors.request.use(
  (config) => {
    // Tokens are now handled via HTTP-only cookies, so no need to add Authorization header
    console.log('Making request to:', `${config.baseURL}${config.url}`);
    console.log('Request config:', {
      method: config.method,
      url: config.url,
      baseURL: config.baseURL,
      headers: config.headers,
      data: config.data
    });
    return config;
  },
  (error) => {
    console.error('Request error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response) => {
    console.log('Response received:', {
      status: response.status,
      url: response.config.url,
      data: response.data
    });
    return response;
  },
  (error) => {
    console.error('Response error:', {
      status: error.response?.status,
      url: error.config?.url,
      data: error.response?.data
    });

    // If unauthorized, show login modal instead of redirecting
    if (error.response?.status === 401) {
      // Dispatch a custom event to show the login modal
      window.dispatchEvent(new CustomEvent('showLoginModal'));
    }

    return Promise.reject(error);
  }
);

export const login = async (credentials) => {
  try {
    const response = await api.post('/login', credentials);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.error || 'Login failed');
  }
};

export const register = async (userData) => {
  try {
    const response = await api.post('/register', userData);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.error || 'Registration failed');
  }
};

export const logout = async () => {
  try {
    await api.post('/logout');
  } catch (error) {
    console.error('Logout error:', error);
  }
};

export default api; 